//
import Model from '@/models/Model'

//
export default class WhStockMovement extends Model {
    //
    static appends = [
        'in', 
        'in_out', 
        'out', 
        'quantity_changed', 
    ]

    /**
     *
     */
    get details() {
        return [
            {
                text: 'Venta en Sala',
                value: this.normal_sale_total,
            },
            {
                text: 'Guia de intercambio',
                value: this.transfer_between_warehouse_total,
            },
            {
                text: 'Venta en Terreno',
                value: this.ground_sale_total,
            },
            {
                text: 'Ajuste de Stock',
                value: this.stock_adjust_total,
            },
            {
                text: 'Compras',
                value: this.purchase_order_total,
            },
            {
                text: 'Reenvasado',
                value: this.repacking_total,
            },
            {
                text: 'Call Center',
                value: this.call_center_sale_total,
            },
            {
                text: 'Venta Empleado',
                value: this.employee_sale_total,
            },
            {
                text: 'Consumo Interno',
                value: this.internal_consumption_total,
            },
            {
                text: 'Cambio de Producto',
                value: this.change_product_customer_total,
            },            
            {
                text: 'Stock inicial',
                value: this.initial_stock_total,
            },            
            {
                text: 'Venta editada',
                value: this.edited_sale_total,
            },            
            {
                text: 'Venta cancelada',
                value: this.cancel_sale_total,
            },
            {
                text: 'Solicitud despacho',
                value: this.getProperty('dispatch_request_total', 0),
            },
            {
                text: 'Reserva',
                value: this.getProperty('reservation_total', 0),
            },
            {
                text: 'Devolucion Reserva',
                value: this.getProperty('reservation_return_total', 0),
            },
        ]//.filter(({ value }) => value != 0)
    }

    /**
     *
     */
    get input_output_total() {
        return Number(this.input_total - this.output_total)
    }

    /**
     *
     */
    get wh_product_name() {
        return this.wh_product ? this.wh_product.name : '-'
    }

    /**
     *
     */
    get wh_warehouse_name() {
        return this.wh_warehouse ? this.wh_warehouse.name : '-'
    }

    //
    static includes = [
        //'transaction',
        'wh_product',
        'wh_warehouse',
        //'wh_warehouse_movement',
    ]

    /**
     *
     */
    resource() {
        return 'wh_stock_movement'
    }
}
